import { FormattedDate, FormattedNumber } from "react-intl";
import { Schedule } from "../../../../PaymentContainerClient/dtos/ConfirmSuccessPaymentResponseDto";
import getFormattedMessageWithScope from "../../../../utils/getFormattedMessageWithScope";
import { useWindowDimensions } from "../../WindowDimensionsProvider";

const fm = getFormattedMessageWithScope("components.PaymentConfirmedSummary");

interface InstallmentProps {
    currency: string;
    installment: Schedule;
    installmentNumber: number;
}

export const Installment = ({
    currency,
    installment,
    installmentNumber,
}: InstallmentProps) => {
    const { width } = useWindowDimensions();

    return (
        <div className="c-PaymentConfirmedSummary-content-installment">
            <div className="c-PaymentConfirmedSummary-content-installment-label-container">
                <span className="c-PaymentConfirmedSummary-content-installment-label">
                    {fm({
                        id:
                            width > 800
                                ? "installment"
                                : "abbreviatedInstallment",
                        values: {
                            installmentNumber: installmentNumber,
                        },
                    })}
                </span>
            </div>
            <div className="c-PaymentConfirmedSummary-content-installment-amount-container">
                <span className="c-PaymentConfirmedSummary-content-installment-amount">
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        value={installment.amount / 100}
                    />
                </span>
            </div>
            <div className="c-PaymentConfirmedSummary-content-installment-deadline-container">
                <span className="c-PaymentConfirmedSummary-content-installment-deadline">
                    {fm("deadline")}{" "}
                    <FormattedDate
                        value={installment.chargeDate}
                        year="numeric"
                        month="2-digit"
                        day="2-digit"
                    />
                </span>
            </div>
        </div>
    );
};
